<template>
  <div
    :style="`background-color: ${bgColor};`"
    class="tc-site-banner"
    :data-testid="dataTestid"
  >
    <div
      class="flex max-w-screen-xl mx-auto py-2 divide-x-2 text-sm *:px-4 justify-start md:justify-center max-md:overflow-x-auto hide-scroll-bar"
    >
      <template v-if="data && data.length > 0">
        <template v-for="item in data" :key="item.id">
          <component
            class="flex gap-1 max-md:min-w-max mx-auto items-center"
            :is="item.link ? NuxtLinkWithLocale : 'div'"
            :to="item.link"
          >
            <TsImage
              v-if="item.image"
              :src="item.image"
              :alt="item.alt"
              width="24"
              height="24"
              loading="lazy"
            />
            <TsTypography
              :style="`color: ${fontColor || customFontColor};`"
              variant="h6"
              weight="semibold"
              >{{ item.text }}</TsTypography
            >
          </component>
        </template>
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
type Data = {
  id: number;
  image?: string;
  alt?: string;
  text: string;
  link?: string;
};

type Props = {
  data: Data[];
  bgColor?: string;
  fontColor?: string;
  customFontColor?: string;
  dataTestid?: string;
};

const props = withDefaults(defineProps<Props>(), {
  bgColor: "#F3F4F6",
  data: () => [
    {
      id: 1,
      image: "/images/logos/delivery-boy.svg",
      alt: "icon 1",
      text: "Gratis bezorging de volgende dag bij bestellingen boven € 25!",
    },
    {
      id: 2,
      image: "/images/logos/delivery.svg",
      alt: "icon 2",
      text: "Mis het niet: exclusieve aanbiedingen zolang de voorraad strekt!",
    },
    {
      id: 3,
      image: "/images/logos/deal.svg",
      alt: "icon 3",
      text: "Black Friday-deals: bespaar flink op elektrisch gereedschap, handgereedschap en meer!",
    },
  ],
});

const NuxtLinkWithLocale = resolveComponent("NuxtLinkWithLocale");
</script>
